import { useMemo } from 'preact/hooks'
import LoaderSpin from 'snippets/loader-spin/loader-spin'

function ProductStatus({ maxQuantity, isLoading }) {
  const { lowStockThreshold } = window.productState
  const { lowStockMessage } = window.productState

  const getContent = (quantity) => {
    if (quantity > 0 && quantity <= lowStockThreshold) {
      return (
        <>
          <p className="mt-3.5 font-semibold text-neutral-900">{translate.product.lowStock}</p>
          {lowStockMessage && maxQuantity > 0 && <p>{lowStockMessage}</p>}
        </>
      )
    }

    if (quantity > lowStockThreshold) {
      return <p className="mt-3.5 font-semibold">{translate.product.inStock}</p>
    }

    return <p className="mt-3.5 font-semibold text-neutral-900">{translate.product.outStock}</p>
  }

  const content = useMemo(() => getContent(maxQuantity), [maxQuantity])

  return !isLoading ? (
    <div className="ml-4 text-sm md:ml-6">{content}</div>
  ) : (
    <div className="px-10 py-2.5">
      <LoaderSpin size={6} />
    </div>
  )
}

export default ProductStatus
